import { ThemeDefinition } from 'vuetify';

export const english: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#E85656',
    'on-subject-original': '#FFFFFF',
    subject: '#DB3333',
    'on-subject': '#FFFFFF',
    primary: '#A21616',
    'on-primary': '#FFFFFF',
    'primary-container': '#F7C5C5',
    'on-primary-container': '#360707',
    secondary: '#744E4E',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#E0D1D1',
    'on-secondary-container': '#251818',
    surface: '#FCF7F7',
    'on-surface': '#201D1D',
    'on-surface-medium': '#504949',
    'on-surface-low': '#9E9494',
    outline: '#867979',
    'outline-variant': '#CFC9C9',
    'inverse-surface': '#422424',
    'inverse-on-surface': '#F6EEEE',
    'inverse-primary': '#F3A5A5',
    'surface-dim': '#EBC2C2',
    'surface-bright': '#FEFBFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF0F0',
    'surface-container': '#F7E8E8',
    'surface-container-high': '#F2D9D9',
    'surface-container-highest': '#F0D1D1',
  },
};

export const englishDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#E85656',
    'on-subject-original': '#FEF6F6',
    subject: '#F29C9C',
    'on-subject': '#360707',
    primary: '#F9D2D2',
    'on-primary': '#360707',
    'primary-container': '#871212',
    'on-primary-container': '#FCE9E9',
    secondary: '#DCCBCB',
    'on-secondary': '#251919',
    'secondary-container': '#5B3E3E',
    'on-secondary-container': '#F5F0F0',
    surface: '#181010',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFC9C9',
    'on-surface-low': '#867979',
    outline: '#9E9494',
    'outline-variant': '#6B6161',
    'inverse-surface': '#EDDEDE',
    'inverse-on-surface': '#281515',
    'inverse-primary': '#5A0C0C',
    'surface-dim': '#150E0E',
    'surface-bright': '#462F2F',
    'surface-container-lowest': '#120C0C',
    'surface-container-low': '#1E1515',
    'surface-container': '#281B1B',
    'surface-container-high': '#342323',
    'surface-container-highest': '#432D2D',
  },
};
